/* eslint-disable react-hooks/exhaustive-deps */
import {
    Add,
    ClearRounded,
    Close,
    CloudDownloadSharp,
    Delete,
    Edit,
    FilePresent,
    SaveOutlined,
    SearchSharp,
} from '@mui/icons-material';
import { Button, CircularProgress, IconButton } from '@mui/material';
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import InfoTooltip from '../tooltip';
import { CustomButtonProps, CustomIconButtonProps, UploadButtonProps } from './Models';

const CustomButton = (props: { icon?: React.ReactNode } & CustomButtonProps) => {
    return (
        <Button
            title={props.text}
            centerRipple
            variant={props.variant ?? 'contained'}
            className={`ks-button ${props.className}`}
            startIcon={props.loading ? <CircularProgress size={20} thickness={5} style={{ marginRight: 5 }} /> : props.icon}
            disabled={props.disabled}
            fullWidth={props.fullWidth}
            onClick={props.onClick}
        >{props.text}</Button>
    )
}

const AddButton = (props: CustomButtonProps) => {
    return (
        <Button
            title={props.text ?? 'EKLE'}
            centerRipple
            variant='contained'
            className={`ks-button btn-primary ${props.className}`}
            startIcon={props.loading ? <CircularProgress size={20} thickness={5} style={{ marginRight: 5 }} /> : <Add />}
            disabled={props.disabled}
            fullWidth={props.fullWidth}
            onClick={props.onClick}
        >{props.text ?? 'EKLE'}</Button>
    )
}

const EditButton = (props: CustomButtonProps) => {
    return (
        <Button
            title={props.text ?? 'DÜZENLE'}
            centerRipple
            variant='contained'
            className={`ks-button btn-primary ${props.className}`}
            startIcon={props.loading ? <CircularProgress size={20} thickness={5} style={{ marginRight: 5 }} /> : <Edit />}
            disabled={props.disabled}
            fullWidth={props.fullWidth}
            onClick={props.onClick}
        >{props.text ?? 'DÜZENLE'}</Button>
    )
}

const DeleteButton = (props: CustomButtonProps) => {
    return (
        <Button
            title={props.text ?? 'SİL'}
            centerRipple
            variant='contained'
            className={`ks-button btn-secondary ${props.className}`}
            startIcon={props.loading ? <CircularProgress size={20} thickness={5} style={{ marginRight: 5 }} />
                : <Delete color={props.disabled ? 'disabled' : 'error'} />}
            disabled={props.disabled}
            fullWidth={props.fullWidth}
            onClick={props.onClick}
        >{props.text ?? 'SİL'}</Button>
    )
}

const SearchButton = (props: CustomButtonProps) => {
    return (
        <Button
            title={props.text ?? 'ARA'}
            centerRipple
            variant='contained'
            className={`ks-button btn-primary ${props.className}`}
            startIcon={props.loading ? <CircularProgress size={20} thickness={5} style={{ marginRight: 5 }} /> : <SearchSharp />}
            disabled={props.disabled}
            fullWidth={props.fullWidth}
            onClick={props.onClick}
        >{props.text ?? 'ARA'}</Button>
    )
}

const ClearButton = (props: CustomButtonProps) => {
    return (
        <Button
            title={props.text ?? 'TEMİZLE'}
            centerRipple
            variant='contained'
            className={`ks-button btn-secondary ${props.className}`}
            startIcon={props.loading ? <CircularProgress size={20} thickness={5} style={{ marginRight: 5 }} /> : <ClearRounded color='error' />}
            disabled={props.disabled}
            fullWidth={props.fullWidth}
            onClick={props.onClick}
        >{props.text ?? 'TEMİZLE'}</Button>
    )
}

const SaveButton = (props: CustomButtonProps) => {
    return (
        <Button
            title={props.text ?? 'KAYDET'}
            centerRipple
            variant='contained'
            className={`ks-button btn-primary ${props.className}`}
            startIcon={props.loading ? <CircularProgress size={20} thickness={5} style={{ marginRight: 5 }} /> : <SaveOutlined />}
            disabled={props.disabled}
            fullWidth={props.fullWidth}
            onClick={props.onClick}
        >{props.text ?? 'KAYDET'}</Button>
    )
}

const DownloadButton = (props: CustomButtonProps) => {
    return (
        <Button
            title={props.text ?? 'İNDİR'}
            centerRipple
            variant="contained"
            className={`ks-button btn-secondary ${props.className}`}
            startIcon={props.loading ? <CircularProgress size={20} thickness={5} /> : <CloudDownloadSharp color="primary" />}
            disabled={props.disabled}
            fullWidth={props.fullWidth}
            onClick={props.onClick}
        >{props.text ?? 'İNDİR'}</Button>
    )
}

const UploadButton = React.forwardRef((props: UploadButtonProps, ref: any) => {

    const inputRef = useRef<HTMLInputElement>(null);

    const handleClearInput = () => {
        if (inputRef.current)
            inputRef.current.value = '';
    }

    const handleClick = () => {
        handleClearInput();
    }

    useImperativeHandle(ref, () => ({
        handleClearInput
    }));

    return (
        <Button
            title={props.text ?? 'YÜKLE'}
            centerRipple
            variant='contained'
            className={`ks-button btn-secondary ${props.className}`}
            startIcon={props.loading ? <CircularProgress size={20} thickness={5} style={{ marginRight: 5 }} /> : <FilePresent color="primary" />}
            disabled={props.disabled}
            component="label"
            fullWidth={props.fullWidth}
            onClick={handleClick}
        >
            {props.text ?? 'YÜKLE'}
            <input hidden accept={props.options.accept ?? "image/*"} multiple={props.options.multiple} type="file"
                onChange={props.options.onChange} ref={inputRef} />
        </Button>
    )
});

// const DeleteIconButton = (props: CustomIconButtonProps) => {

//     const [loading, setLoading] = useState<boolean>(false);

//     const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
//         setLoading(true);
//         props.onClick(event);
//     }

//     useEffect(() => {
//         if (!props.disabled && loading) {
//             setLoading(false);
//         }
//     }, [props.disabled])


//     return (
//         <InfoTooltip title={props.title ?? 'Sil'}>
//             <IconButton
//                 centerRipple
//                 className={props.className}
//                 onClick={handleClick}
//                 disabled={props.disabled}
//                 color={props.color}
//             >
//                 {
//                     loading ? <CircularProgress size={16} thickness={5} /> : <i className='flaticon-delete icon-xs'></i>
//                 }
//             </IconButton>
//         </InfoTooltip>
//     )
// }

const CloseIconButton = (props: CustomIconButtonProps) => {
    return (
        <IconButton
            title='Kapat'
            className={props.className}
            onClick={props.onClick}
            disabled={props.disabled}
            color={props.color}
        ><Close /></IconButton>
    )
}

const CustomIconButton = (props: { icon: React.ReactNode } & CustomIconButtonProps) => {
    return (
        <InfoTooltip title={props.title ?? ''}>
            <IconButton
                centerRipple
                className={props.className}
                onClick={props.onClick}
                disabled={props.disabled}
                color={props.color}
            >{props.icon}</IconButton>
        </InfoTooltip>
    )
}

export {
    CustomButton,
    AddButton, EditButton, DeleteButton, SearchButton, ClearButton, SaveButton, UploadButton, DownloadButton, 
    CloseIconButton, CustomIconButton
};